import { validate } from 'uuid';

export const validateValue = (
  costCodesId: string,
  costCodesOptions: { value: string; label: string }[],
  costCodesIdToCodeAndNameMap: Map<string | null, string>,
) => {
  return !costCodesOptions.some(({ value }) => value === costCodesId)
    ? costCodesIdToCodeAndNameMap.get(costCodesId)
    : costCodesId;
};

export const mapNameToCode = (costCodesId: string, costCodesCodeToIdMap: Map<string, string | null>) => {
  if (typeof costCodesId === 'string' && !validate(costCodesId)) {
    return costCodesCodeToIdMap.get(costCodesId) || null;
  }
  return costCodesId;
};
